/**
 * Step 20E2: Disponibilidade para Treinamento de Vendas
 * Coleta interesse e disponibilidade para treinamentos iniciais
 */

import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20E2_Treinamento: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.disponivelTreinamentoVendas) newErrors.disponivelTreinamentoVendas = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ disponivelTreinamentoVendas: data.disponivelTreinamentoVendas });
  };

  const handleFieldChange = (value: string) => {
    updateField('disponivelTreinamentoVendas', value);
    if (errors.disponivelTreinamentoVendas) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.disponivelTreinamentoVendas;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">Você tem disponibilidade para participar dos treinamentos iniciais sobre vendas e a plataforma Xizinha?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Os treinamentos são realizados de forma online e são essenciais para o início das suas atividades como Embaixadora X.
        </p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Sim, tenho disponibilidade e muito interesse', value: 'disponivel-interessada' },
            { label: 'Tenho interesse, mas disponibilidade limitada', value: 'interesse-limitada' },
            { label: 'Tenho disponibilidade, mas não tenho interesse', value: 'disponivel-sem-interesse' },
            { label: 'Não tenho disponibilidade no momento', value: 'sem-disponibilidade' },
          ]}
          selected={data.disponivelTreinamentoVendas || ''}
          onSelect={handleFieldChange}
        />
        {errors.disponivelTreinamentoVendas && (
          <p className="text-red-600 text-sm mt-2">{errors.disponivelTreinamentoVendas}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20E2_Treinamento;
